import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class ServerDownModal extends React.Component {
  static propTypes = {
    hideModal: PropTypes.func
  }
  componentDidMount() {}
  render() {
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        maxWidth={'sm'}
        title={`Erreur Serveur`}
        cancelText="Fermer"
        showOk={false}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              Dashpool rencontre actuellement des soucis sur ses serveurs...
            </Typography>
            <Typography variant="caption" gutterBottom>
              Un ticket a été envoyé au support. Nous faisons tout notre
              possible pour résoudre le problème.
            </Typography>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(ServerDownModal)



// WEBPACK FOOTER //
// ./src/components/modals/common/ServerDownModal.js